export const monitoringCommingSoonData = [
    {
        name: "Express Lane",
        issue: "New Bankruptcy Detected",
        startDate: "Jun 01, 2025",
    },
    {
        name: "Long Haul",
        issue: "Management Change Detected",
        startDate: "Jun 01, 2025",
    },
    {
        name: "Swift LLC",
        issue: "New UCC Filings",
        startDate: "Jun 01, 2025",
    },
    {
        name: "Pacific Transports",
        issue: "Safety Rating Changes",
        startDate: "Jun 01, 2025",
    },
]

export const monitoringFeatures = [
    {
        title: 'FMCSA Monitoring',
        items: [
            'Operating status changes (e.g., Active to Out of Service)',
            'Safety rating updates',
            'Insurance updates',
        ],
    },
    {
        title: 'Background Check Monitoring',
        items: [
            'New criminal records',
            'Updates to existing records',
            'New Bankruptcies',
            'Liens and judgements',
        ],
    },
    {
        title: 'Business Verification Monitoring',
        items: [
            'Changes in business status (e.g., Verified to Closed)',
            'Name or address updates',
            'Ownership or structure changes',
        ],
    },
    {
        title: 'UCC Search Monitoring',
        items: ['New UCC filings', 'Releases or terminations of existing liens'],
    },
    {
        title: 'SOS (Secretary of State) Monitoring',
        items: ['Status changes (e.g., Active to Dissolved)'],
    },
];
